














































































































import { Base } from '@master/model/Base'
import AppCheckboxGroup from '@core/components/AppCheckboxGroup.vue'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppSmartSelect from '@core/components/AppSmartSelect.vue'
import { TableFormStructure, TableInput } from '@master/model/structure/FormStructure'
import { IDateService } from '@master/services/IDateService'
import { inject } from 'inversify-props'
import { isNull, isUndefined } from 'lodash/fp'
import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDateInput from './AppDateInput.vue'
import { getMaxChar } from '@master/annotation/MaxChar'

@Component({
  components: {
    AppCheckboxGroup,
    AppRadioSelection,
    AppSmartSelect,
    AppDateInput
  }
})
export default class AppFormTable<T extends Base> extends Vue {
  @Prop({ default: false }) readonly innerTable: boolean
  @Prop() readonly loading!: boolean
  @Prop({ default: false }) readonly vertical!: object | boolean
  @Prop() readonly fields!: TableFormStructure<T>
  @Prop() readonly data!: Array<T>
  @Prop() readonly maxSize?: number
  @Prop() readonly errors?: { key: string; msg: string }[][]
  @Prop({ default: true }) readonly show!: boolean

  protected editMode = false

  @inject()
  private dateService: IDateService

  get rows () {
    return this.vertical ? this.fields : this.data
  }

  get cols () {
    return this.vertical ? this.data : this.fields
  }

  get maxSizeReached () {
    return this.maxSize ? this.data.length >= this.maxSize : false
  }

  getError (idx: number, key: string) {
    if (!this.errors) return undefined
    return this.errors[idx]?.find(err => err.key === key)?.msg
  }

  getFieldMaxChar (idx: number, key: string) {
    return getMaxChar(this.data[idx], key)
  }

  getCharMsg (idx: number, key: string) {
    const maxChar = this.getFieldMaxChar(idx, key)
    const charLeft = this.getCharLeft(idx, key)
    return maxChar ? (charLeft > 0 ? `${charLeft} letters remaining` : 'Max character limit reached') : ''
  }

  shouldDisabled (row: number, condition: boolean | Function = false) {
    if (condition === undefined) {
      return false
    } else if (condition instanceof Function) {
      return condition(this.data[row])
    } else {
      return condition
    }
  }

  onBlur (row: number, config: TableInput<T>) {
    const key = config.key
    const defaultValue = config.default
    const defaultTo = config.defaultTo
    if (!isUndefined(defaultValue || defaultTo) && !isNull(defaultValue || defaultTo)) {
      const target = this.data[row]
      const defaultToVal = target[defaultTo]
      Object.assign(target, { [key]: target[key] || defaultValue || defaultToVal })
      this.$set(this.data, row, target)
    }
  }

  getId (model: any, key: string) {
    if ('snakeCaseKey' in model) {
      return model.snakeCaseKey(key)
    }
    return undefined
  }

  getLabelId (model: any, key: string) {
    return this.getId(model, key) + '_label'
  }

  getCharLeft (idx: number, key: string) {
    const mc = getMaxChar(this.data[idx], key)
    return mc ? mc - this.data[idx][key]?.length || 0 : mc
  }

  getValue (idx: number, field: any) {
    if (field.key) {
      return this.data[idx][field.key]
    } else if (field.model) {
      return field.model.get()
    } else {
      throw new Error(`Invalid config for label ${field.label}: key or model is required`)
    }
  }

  setValue (idx: number, field: any, value: any) {
    // console.log('setValue', idx, field, value)
    let finalValue = value
    if (value instanceof InputEvent) finalValue = (value.target as any).value
    if (field.key) {
      const target = { ...this.data[idx] }
      // console.log(Object.getOwnPropertyDescriptor(target, field.key)?.set)
      // if (isUndefined(Object.getOwnPropertyDescriptor(target, field.key)?.set)) return
      target[field.key] = finalValue
      this.data.splice(idx, 1, target)
    } else if (field.model) {
      return field.model.set(finalValue)
    } else {
      throw new Error(`Invalid config for label ${field.label}: key or model is required`)
    }
  }

  addDataItem () {
    if (this.maxSizeReached) return
    this.$emit('add')
  }

  removeDataItem (idx) {
    this.$emit('remove', idx)
  }
}
